import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text, { H1 } from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import { A } from 'components/common/Link/Link'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Back from 'components/common/Back'
import { SearchFromHeader } from '../SavedLocationSearchForm'
import { Section, PageOptionsSection } from '../SharedStyledComponents'

const StoreLocatorSearchSummary = ({
  totalSearchResultsLength,
  searchTitle,
  flags: { showSearchForm = false },
  toggleFlagHandler,
  resetSearchAction,
  withBackButton = true,
  withPageHeader = true,
  ...props
}) =>
  totalSearchResultsLength > 0 ?
    <Section>
      {
        withBackButton &&
        <PageOptionsSection>
          <Back data-at-storelocator-backlink handler={ resetSearchAction }>Back</Back>
        </PageOptionsSection>
      }
      <TitleWrapper>
        <SplitHeader>
          {
            withPageHeader &&
            <Header data-at-store-locator-search-summary-header headline noMargin>Store Locator</Header>
          }
          <SearchToggler data-at-change-location-button prevent bolder handler={ () => toggleFlagHandler('showSearchForm') }>
            Change location <Icon asset="arrow-down" alternative="arrow-up" condition={ showSearchForm } width={ 10 } height={ 10 } />
          </SearchToggler>
        </SplitHeader>
        <Results data-at-store-locator-search-summary-result block size={ 20 }>{ searchTitle }</Results>
        {
          showSearchForm &&
            <SearchWrapper>
              <SearchFromHeader { ...props } />
            </SearchWrapper>
        }
      </TitleWrapper>
    </Section> :
    <Fragment>
      {
        withPageHeader &&
        <Section>
          <HeaderWithPadding data-at-store-locator-title narrow headline block>Store Locator</HeaderWithPadding>
        </Section>
      }
    </Fragment>

export default StoreLocatorSearchSummary

StoreLocatorSearchSummary.propTypes = {
  flags: PropTypes.shape({
    showSearchForm: PropTypes.bool
  }),
  resetSearchAction: PropTypes.func,
  searchTitle: PropTypes.string,
  toggleFlagHandler: PropTypes.func,
  totalSearchResultsLength: PropTypes.number,
  withBackButton: PropTypes.bool,
  withPageHeader: PropTypes.bool
}

const TitleWrapper = styled.div`
  position: relative;
`

const SplitHeader = styled.div`
  ${Mixin.clearFix()}
`

const Header = styled(H1)`
  float: left;
  ${Mixin.font.GothamBold(26, 600)}
  ${Media.mobile`
    font-size: 20px;
  `}
  ${Media.mobileNarrow`
    font-size: 18px;
  `}
`

const HeaderWithPadding = styled(H1)`
  ${Mixin.font.GothamBold(26, 600)}
  ${Mixin.responsive('padding', '0', '27px 0 17px 0')}
`

const SearchToggler = styled(A)`
  float: right;
  ${Mixin.responsive('line-height', '40px', '30px')}
  ${Mixin.mobileOnly()};
`

const SearchWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 70px;
  right: 0;
  z-index: 2;
  padding: 0 20px;
  ${Mixin.mobileOnly()};
`

const Results = styled(Text)`
  margin-top: 16px;
  ${Mixin.desktopOnly()};
`
